import {Card, CardHeader, Col, Container, Row } from "reactstrap";
import SimpleHeader from "../../components/SimpleHeader/SimpleHeader";
import Button from "../../components/UIButton/UIButton";

export default function DsaRecipientPage() {
	return (
		<>
			<SimpleHeader
				name="Receiver"
				parentName="Data Sharing Agreements - Receiver"
			/>
			<Container className="mt--6" fluid>
				<Row className="justify-content-center">
					<Col className="card-wrapper">
						<Card className="card-header-devices">
							<CardHeader>
								<Container fluid>
									<Row>
										<Col>
											<h2>Received Agreements</h2>
										</Col>
									</Row>
									<Row>
										<Col >&nbsp;</Col>
										<Col  className="justify-content-end d-flex">
											<Row className="my-2 align-items-center">
												
													<Button
														variant="primary"
														size="medium"
														onClick={() => { }}
													>
														Enter Agreement Code
													</Button>

											</Row>
										</Col>
									</Row>
								</Container>
							</CardHeader>
						</Card>
					</Col>
				</Row>
			</Container>
		</>
	);
}
